export var AccountConfigManager = (function() {
    var self = {};
    var missingProperties = {};

    self.getConfig = function(configManager) {
        self.configManager = configManager.getConfig() || { site: {} };
        self.newConfigurations = {};
        self.newConfigurations.site = nuskin.configuration.mecSite;

        // Creates and assigns the most up-to-date values and variables to the existing
        var mergedSiteConfigs = Object.assign(self.configManager.site, self.newConfigurations.site);

        // Append missing parameters and value to the .site property.
        missingProperties.site = {};
        if (Object.keys(missingProperties.site).length > 0) {
            console.error('Configurations from missingProperties: nuskin-mec-common -> AccountConfigManager.js' +
                ' are overriding values.');
        }

        // Appends missing properties here when global-ui is down...
        self.configManager.site = Object.assign(mergedSiteConfigs, missingProperties.site);

        return self.configManager;
    };

    return self;
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/config-manager/AccountConfigManager.js
// module id = 7
// module chunks = 0